import { Component, triggerPublicEvent } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';

const enum Selectors {
	Input = '.js-a-checkbox__input',
}

@Component('Checkbox')
export class Checkbox extends GondelJqueryComponent {
	public sync() {
		$(Selectors.Input, this.$ctx).one('focus', () => triggerPublicEvent('gFormInteractionEvent', this));
	}
}
